
import { createOpportunity, updateOpportunity } from "../api/OpportunityService";
import React, { useState, useEffect } from "react";
import { fetchPipelineStages, fetchOpportunityStatuses, fetchLeads, fetchCustomers, fetchSalesReps } from "../api/OpportunityService";
import { fetchUsers } from "../api/userService";
import UserSearchDropdown from "../components/UserSearchDropdown"; 
import CustomerSearchDropdown from "../components/CustomerSearchDropdown";
import { fetchServiceCategories } from "../api/serviceCategoryService";
import { X } from "lucide-react"; // ✅ Import Lucide React close icon

function OpportunityForm({ opportunity, onClose, onSave = () => {}, lead }) {
  const [formData, setFormData] = useState(
    opportunity || {
      lead_id: lead?.lead_id || "", // Autopopulate lead_id if lead is provided
      customer_id: "",
      customer_name: "", // Store customer name for display
      opportunity_name: lead ? `${lead.first_name} ${lead.last_name} Deal` : "", // Autopopulate opportunity_name if lead is provided
      product_service: "",
      pipeline_stage_id: "",  // Add this
     // opportunity_status_id: "",  // Add this
      status_id: "",  // Add this
      pipeline_stage: "",
      estimated_value: "",
      probability: "",
      status: "",
      reason_for_loss: "",
      assigned_to: "",
      assigned_to_username: "", // Store user name for display
      expected_close_date: "",
    }
  );

  /*useEffect(() => {
    if (opportunity) {
      setFormData({
        ...opportunity,
        status_id: opportunity.opportunity_status_id || "", // 🔥 FIX: Map `opportunity_status_id` to `status_id`
      });
    }
  }, [opportunity]);*/

  
  const [pipelineStages, setPipelineStages] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [leads, setLeads] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [salesReps, setSalesReps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [serviceCategories, setServiceCategories] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
 
  useEffect(() => {
    if (lead) {
      setFormData((prev) => ({
        ...prev,
        lead_id: lead.lead_id,
        opportunity_name: `${lead.first_name} ${lead.last_name} Deal`, // Derive opportunity name from lead name
      }));
    }
  }, [lead]);

  useEffect(() => {
    const loadFormOptions = async () => {
      try {
        console.log("🚀 Inside Load Form Options:");
        const [stages, statuses, leadList, categories] = await Promise.all([
          fetchPipelineStages(),
          fetchOpportunityStatuses(),
          fetchLeads(),
          fetchServiceCategories(),
        ]);
  
        console.log("🚀 Pipeline Stages in Form:", stages);
        console.log("🚀 Opportunity Statuses in Form:", statuses);
  
        // ✅ Ensure data is always an array
        setPipelineStages(Array.isArray(stages) ? stages : []);
        setStatuses(Array.isArray(statuses) ? statuses : []);
        setLeads(Array.isArray(leadList) ? leadList : []);
        //setCustomers(Array.isArray(customerList) ? customerList : []);
        //setSalesReps(Array.isArray(salesRepList) ? salesRepList : []);
        setServiceCategories(Array.isArray(categories) ? categories : []); // ✅ Store in state
      } catch (error) {
        console.error("❌ Error loading form options:", error);
      } finally {
        setLoading(false);
      }
    };
  
    loadFormOptions();
  }, []);

  useEffect(() => {
    if (opportunity) {
      console.log("🚀 Editing Opportunity:", opportunity);
  
      setFormData((prev) => ({
        ...prev,
        customer_id: opportunity.Customer?.customer_id || "", // ✅ Ensure correct customer ID
        customer_name: opportunity.Customer?.company_name || opportunity.Customer?.name || "", // ✅ Ensure correct customer name
        assigned_to: opportunity.User?.user_id || "", // ✅ Ensure correct assigned user ID
        assigned_to_username: opportunity.User 
          ? `${opportunity.User.first_name} ${opportunity.User.last_name}` 
          : "", // ✅ Ensure correct assigned user name
              }));
              
    }
  }, [opportunity]); // ✅ Now runs every time `opportunity` changes

  console.log('assigned_to_user_name:',formData.assigned_to_username);
  console.log('Customer Name:',formData.customer_name);
  useEffect(() => {
    console.log("🚀 Editing Opportunity:", opportunity);
    console.log("📌 Loaded Statuses:", statuses);
  
    if (opportunity && statuses.length > 0) {
      const selectedStatus = statuses.find(
        (status) => status.opportunity_status_id === opportunity.status_id
      );
  
      console.log("✅ Selected Status:", selectedStatus);
  
      setFormData((prev) => ({
        ...prev,
        status_id: selectedStatus ? selectedStatus.opportunity_status_id : "", // ✅ Set status correctly
      }));
    }
  }, [opportunity, statuses]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

 
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setErrorMessage(""); // Reset previous error messages
  
    // ✅ Ensure all required fields are set
    console.log('Status_ID form data ',formData.status_id);
    if (!formData.opportunity_name || !formData.pipeline_stage_id || !formData.status_id) {
      setErrorMessage("Opportunity Name, Pipeline Stage selection, and Status selection are required.");
      console.error("❌ Validation Error: Missing required fields.");
      setSubmitting(false);
      return;
    }
  
    try {
      const formattedData = {
        opportunity_name: formData.opportunity_name,
        product_service: formData.product_service,
        estimated_value: formData.estimated_value,
        probability: formData.probability,
        expected_close_date: formData.expected_close_date,
        lead_id: formData.lead_id,
        customer_id: formData.customer_id || null, // Ensure correct ID
        assigned_to: formData.assigned_to || null, // Ensure correct Sales Rep ID
        pipeline_stage_id: parseInt(formData.pipeline_stage_id, 10), // ✅ Correct field name
        status_id: parseInt(formData.status_id, 10), // ✅ Correct field name
      };
      
      console.log("📡 Sending API Request with Data:", formattedData);
      //await createOpportunity(formattedData);

 
      let result;
      if (opportunity) {
        result = await updateOpportunity(opportunity.opportunity_id, formattedData);
        setSuccessMessage(`Opportunity "${result.opportunity_name}" updated successfully!`);
      } else {
        result = await createOpportunity(formattedData);
        setSuccessMessage(`Opportunity "${result.opportunity_name}" created successfully!`);
      }

      if (!result || (result.error && result.error !== null)) {
        setErrorMessage(result?.error || "Failed to save opportunity.");
        return;
      }
      setErrorMessage(""); // ✅ Clear previous errors
      onSave(result);
      // Auto-close after 3 seconds
    setTimeout(() => {
      onClose();
      setSuccessMessage("");
    }, 3000);
    } catch (error) {
      console.error("❌ API Error saving opportunity:", error);
      setErrorMessage("Failed to save opportunity. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
  <div className="bg-white w-full max-w-3xl rounded-xl shadow-lg flex flex-col max-h-[90vh] relative">
  <button
    onClick={onClose}
    className="absolute top-4 right-4 text-gray-500 hover:text-red-600 transition-colors"
    aria-label="Close"
  >
    <X size={24} />
  </button>
  <div className="p-6 border-b font-semibold text-lg bg-gray-100 rounded-t-xl">
  {opportunity ? "Edit Opportunity" : "Add Opportunity"}
      {/* ✅ Close Icon (Top Right) */}
      
   
</div>

        {/* Add this block below the error message */}
      {successMessage && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
          {successMessage}
        </div>
      )}
        {/* 🔴 Error Message Display Here */}
      {errorMessage && (
        <p className="text-red-600 text-sm mb-4 text-center">{errorMessage}</p>
      )}
        <div className="p-6 overflow-y-auto flex-grow space-y-4">
        <form id="opportunity-form" onSubmit={handleSubmit}>
        {/* Two-Column Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Lead ID */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Lead ID
            </label>
            <input
              type="number"
              name="lead_id"
              value={formData.lead_id}
              onChange={handleChange}
              className="block w-full mt-1 border-gray-300 rounded-md shadow-sm"
              placeholder="Enter Lead ID"
              readOnly={!!lead} // Make the field read-only if lead is provided
            />
          </div>

          {/* Customer ID */}
          <div>
  <label className="block text-sm font-medium text-gray-700">
    Customer
  </label>
  <CustomerSearchDropdown
  value={formData.customer_name} // ✅ Display customer name in input
  onChange={(customer) =>
    setFormData((prev) => ({
      ...prev,
      customer_id: customer.customer_id, // ✅ Store customer ID for backend
      customer_name: customer.customer_name, // ✅ Store name for display
    }))
  }
/>
</div>

          {/* Opportunity Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Opportunity Name
            </label>
            <input
              type="text"
              name="opportunity_name"
              value={formData.opportunity_name}
              onChange={handleChange}
              className="block w-full mt-1 border-gray-300 rounded-md shadow-sm"
              placeholder="Enter Opportunity Name"
              required
            />
          </div>

          {/* Product/Service */}
          <div>
  <label className="block text-sm font-medium text-gray-700">
    Product/Service
  </label>
  <select
    name="product_service"
    value={formData.product_service}
    onChange={handleChange}
    className="block w-full mt-1 border-gray-300 rounded-md shadow-sm"
    required
  >
    <option value="">Select Product/Service</option>
    {serviceCategories.map((category) => (
      <option key={category.id} value={category.name}>
        {category.name}
      </option>
    ))}
  </select>
</div>

          {/* Pipeline Stage */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Pipeline Stage
            </label>
            {/* Pipeline Stage */}
<div>
  {/*<label className="block text-sm font-medium text-gray-700">
    Pipeline Stage
  </label>*/}
<select
  name="pipeline_stage_id"
  value={formData.pipeline_stage_id || ""} // ✅ Ensuring the dropdown reflects the selected ID
  onChange={(e) => {
    const selectedStage = pipelineStages.find(stage => stage.pipeline_stage_id === parseInt(e.target.value, 10));
    setFormData((prev) => ({
      ...prev,
      pipeline_stage_id: selectedStage ? selectedStage.pipeline_stage_id : "", // ✅ Store ID
    }));
  }}
>
  <option value="">Select Pipeline Stage</option>
  {pipelineStages.map((stage) => (
    <option key={stage.pipeline_stage_id} value={stage.pipeline_stage_id}>{stage.name}</option> // ✅ Correct display
  ))}
</select>
</div>
          </div>

          {/* Estimated Value */}
          <div>
  <label className="block text-sm font-medium text-gray-700">
    Estimated Value ({process.env.REACT_APP_CURRENCY_SYMBOL || "$"}) 
  </label>
  <input
    type="number"
    name="estimated_value"
    value={formData.estimated_value}
    onChange={handleChange}
    className="block w-full mt-1 border-gray-300 rounded-md shadow-sm"
    placeholder={`Enter Estimated Value (${process.env.REACT_APP_CURRENCY_SYMBOL || "$"})`} 
    required
  />
  {/* ✅ Correct: Moved comment outside JSX */}
  {/* Use currency symbol from .env */}
</div>
          {/* Probability */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Probability (%)
            </label>
            <input
              type="number"
              name="probability"
              value={formData.probability}
              onChange={handleChange}
              className="block w-full mt-1 border-gray-300 rounded-md shadow-sm"
              placeholder="Enter Probability"
              required
            />
          </div>

          {/* Status */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Status
            </label>
            {/* Status */}
<div>
  {/*<label className="block text-sm font-medium text-gray-700">
    Status
  </label>*/}
<select
  name="status_id"  // ✅ Use "status_id" instead of "opportunity_status_id"
  value={formData.status_id || ""} // ✅ Ensure correct field is used
  onChange={(e) => {
    const selectedStatus = statuses.find(
      (status) => status.opportunity_status_id === parseInt(e.target.value, 10)
    );
    setFormData((prev) => ({
      ...prev,
      status_id: selectedStatus ? selectedStatus.opportunity_status_id : "", // ✅ Store correct status_id
    }));
  }}
  className="block w-full mt-1 border-gray-300 rounded-md shadow-sm"
>
  <option value="">Select Status</option>
  {statuses.map((status) => (
    <option key={status.opportunity_status_id} value={status.opportunity_status_id}>
      {status.name}
    </option>
  ))}
</select>
</div>
          </div>

          {/* Reason for Loss */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Reason for Loss
            </label>
            <input
              type="text"
              name="reason_for_loss"
              value={formData.reason_for_loss}
              onChange={handleChange}
              className="block w-full mt-1 border-gray-300 rounded-md shadow-sm"
              placeholder="Enter Reason for Loss (if applicable)"
            />
          </div>

          {/* Assigned To */}
          <div>
  <label className="block text-sm font-medium text-gray-700">
    Assigned To
  </label>
  <UserSearchDropdown
    value={formData.assigned_to_username} // Show username in UI
    onChange={(user) =>
      setFormData((prev) => ({
        ...prev,
        assigned_to: user.user_id, // Store user_id for backend
        assigned_to_username:user.fullName , // ✅ Store assigned user name for display
      }))
    }
  />
</div>

          {/* Expected Close Date */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Expected Close Date
            </label>
            <input
              type="date"
              name="expected_close_date"
              value={formData.expected_close_date}
              onChange={handleChange}
              className="block w-full mt-1 border-gray-300 rounded-md shadow-sm"
              required
            />
            
          </div>
          </div>
          </form>
          </div>
          
  
        
        
       
        

        {/* Sticky Footer for Buttons  */}
        <div className="p-4 border-t bg-gray-100 flex justify-end space-x-3 rounded-b-xl">
      <button onClick={onClose} className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md mr-2">
        Cancel
      </button>
      <button
        type="submit"
        form="opportunity-form"  // ✅ Links to the form
        className={`px-4 py-2 text-white bg-blue-600 rounded-md ${submitting ? "opacity-50 cursor-not-allowed" : ""}`}
        disabled={submitting}
      >
        {submitting ? "Saving..." : "Submit"}
      </button>
   

{/*<div className="p-4 border-t flex justify-end bg-gray-100">
      <button onClick={onClose} className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md mr-2">
        Cancel
      </button>
      <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-md">
        Submit
      </button>*/}
    </div>
</div>
        </div>
        
     
    
  );
}

export default OpportunityForm;